export default "__VITE_ASSET__CV_N2UP5__"